export default "__VITE_ASSET__fb10d6da__"